module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNjciIHZpZXdCb3g9IjAgMCAxNiA2NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuOTk5OTMgMEw4IDU5IiBzdHJva2U9IiNEMkQyRDIiIHN0cm9rZS1kYXNoYXJyYXk9IjQgNCIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iNTguNSIgcj0iOCIgZmlsbD0iI0Q1RUREQiIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iNTguNSIgcj0iNSIgZmlsbD0iIzRGQTQ2MiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/tracking-dots.svg
// module id = Fxrd
// module chunks = 0